export function isInvalidID(idStr, resident) {
  if (idStr === undefined || idStr === null) {
    return true;
  }

  const identityNumberRegex = /^[A-Z][1|2]\d{8}$/;
  const oldResidentNumberRegex = /^[A-Z][A|B|C|D]\d{8}$/;
  const newResidentNumberRegex = /^[A-Z][8|9]\d{8}$/;
  let isNewResidentRule = false;

  if (resident) {
    if (newResidentNumberRegex.test(idStr)) {
      isNewResidentRule = true;
    } else if (!oldResidentNumberRegex.test(idStr)) {
      return true;
    }
  }
  if (!resident && !identityNumberRegex.test(idStr)) return true;

  // 依照字母的編號排列，存入陣列備用。
  const letters = new Array('A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'J', 'K', 'L', 'M', 'N',
                            'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'X', 'Y', 'W', 'Z', 'I', 'O');
  // 儲存各個乘數
  const multiply = new Array(1, 9, 8, 7, 6, 5, 4, 3, 2, 1, 1);
  const nums = new Array(3);
  // 取出第一個字元
  const firstChar = idStr.charAt(0).toUpperCase();
  let firstNum;
  let total = 0;
  // 找出第一個字母對應的數字，並轉換成兩位數數字。
  for (let i = 0; i < 26; i++) {
    if (firstChar === letters[i]) {
      firstNum = i + 10;
      nums[0] = Math.floor(firstNum / 10);
      nums[1] = firstNum - (nums[0] * 10);
      break;
    }
  }
  if (resident) {
    const secondChar = idStr.charAt(1).toUpperCase();
    let secondNum;
    if (isNewResidentRule) {
      nums[2] = idStr.charAt(1);
    } else {
      // 計算居留證第二英文個位數
      for (let i = 0; i < 4; i++) {
        if (secondChar === letters[i]) {
          secondNum = i + 10;
          const tenDigit = Math.floor(secondNum / 10);
          nums[2] = secondNum - (tenDigit * 10);
        }
      }
    }
    // 計算居留證總和
    for (let i = 0; i < multiply.length; i++) {
      if (i < 3) {
        total += nums[i] * multiply[i];
      } else {
        total += parseInt(idStr.charAt(i - 1), 10) * multiply[i];
      }
    }
  } else {
    // 身分證總和
    for (let i = 0; i < multiply.length; i++) {
      if (i < 2) {
        total += nums[i] * multiply[i];
      } else {
        total += parseInt(idStr.charAt(i - 1), 10) * multiply[i];
      }
    }
  }
  // 整除十等於0 為正確身分證/居留證
  if ((total % 10) === 0) {
    return false;
  }
  return true;
}



/** WEBPACK FOOTER **
 ** D:/a/1/s/Tube.Frontend/src/containers/App/screens/Foundation/utils/verify.js
 **/